// Lightweight base64 helpers (avoid external dependency)
function base64ToUint8Array(base64) {
    const binary = window.atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}

function uint8ArrayToBase64(uint8arr) {
    let binary = "";
    for (let i = 0; i < uint8arr.length; i++) {
        binary += String.fromCharCode(uint8arr[i]);
    }
    return window.btoa(binary);
}

export async function encryptAesGcm(base64Key, plaintext) {
    const keyBytes = base64ToUint8Array(base64Key);
    const key = await window.crypto.subtle.importKey(
        'raw',
        keyBytes.buffer,
        { name: 'AES-GCM' },
        false,
        ['encrypt']
    );

    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    const encoder = new TextEncoder();
    const encodedText = encoder.encode(plaintext);

    const ciphertext = await window.crypto.subtle.encrypt(
        {
            name: 'AES-GCM',
            iv,
        },
        key,
        encodedText
    );

    const ctArray = new Uint8Array(ciphertext);
    const combined = new Uint8Array(iv.length + ctArray.length);
    combined.set(iv, 0);
    combined.set(ctArray, iv.length);
    return uint8ArrayToBase64(combined);
}